import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueCookies from 'vue-cookies';
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";
import FbPixel from "vue-facebook-pixel";
/*import Hotjar from "vue-hotjar";*/
import CountryFlag from 'vue-country-flag';
import CountryLocation from '@/components/country-location';
import axios from 'axios'
import VueAxios from 'vue-axios'
import '@/components'; // Auto-register components in components folder

Vue.use(VueAxios, axios)
Vue.use(VueMeta);
Vue.use(VueCookies);
Vue.use(VueGtag, {
    config: { id: "UA-87987832-3" }
}, router);
Vue.use(FbPixel, { router, debug: false });
/*Vue.use(Hotjar, {id: '2371431'});*/

Vue.analytics.fbq.init("167149004780099");
Vue.component('country-flag', CountryFlag);
Vue.component('country-location', CountryLocation);

Vue.config.productionTip = false;

new Vue({
    router,
    render: function (h) { return h(App); },
    mounted() {
        document.dispatchEvent(new Event('x-app-rendered'));
    },
    data: {
        countryCode: '',
        showVAT: false,
        vatRate: 1.2
    }
}).$mount('#app');
